
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 23.253H5.25a1.5 1.5 0 0 1-1.5-1.5v-10.5h16.5v10.5a1.5 1.5 0 0 1-1.5 1.5Zm1.5-12.753a8.25 8.25 0 0 0-16.5 0v.75h16.5Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.625 6.753a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375m6.75 0a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375M7.359 3.682 5.25.753m11.391 2.929L18.75.753m-15 10.5a3 3 0 0 0-3 3v6m19.5-9a3 3 0 0 1 3 3v6","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    